import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FrontFirstPermissionTreeModule } from '../front-first-permission-tree/front-first-permission-tree.module';
import { PermissionSelectorComponent } from './permission-selector.component';

@NgModule({
  declarations: [PermissionSelectorComponent],
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FrontFirstPermissionTreeModule,
  ],
  exports: [PermissionSelectorComponent],
})
export class PermissionSelectorModule {}
